var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeElement02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 793,
    viewBox: "0 0 1920 793",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-62 587.116C602.036 633.208 828.863 910.259 1122.85 643.728C1358.04 430.504 1870.94 499.108 2098 560.062",
    stroke: "url(#paint0_linear_1043_40040)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-63.0341 587.353C602.934 611.559 846.46 880.352 1123.69 604.991C1345.47 384.703 1861.9 436.303 2092.39 489.639",
    stroke: "url(#paint1_linear_1043_40040)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-61.7885 586.562C604.992 583.502 868.765 841.916 1124.43 555.654C1328.95 326.644 1848.53 357.049 2082.75 400.877",
    stroke: "url(#paint2_linear_1043_40040)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-58.0135 585.426C607.794 558.962 888.29 807.817 1124.79 512.911C1313.99 276.987 1834.97 289.116 2071.81 324.671",
    stroke: "url(#paint3_linear_1043_40040)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.8746 585.919C597.815 547.284 886.768 790.929 1113.07 491.79C1294.11 252.478 1815.34 255.073 2053.33 286.285",
    stroke: "url(#paint4_linear_1043_40040)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-68.2205 586.45C593.423 526.077 897.069 760.01 1104.74 453.758C1270.88 208.756 1791.75 194.272 2031.42 217.655",
    stroke: "url(#paint5_linear_1043_40040)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-67.1806 585.514C588.79 498.185 909.914 719.337 1093.76 405.074C1240.83 153.665 1759.77 117.908 2000.85 131.456",
    stroke: "url(#paint6_linear_1043_40040)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-63.734 583.918C585.723 473.661 921.048 683.284 1083.97 362.931C1214.31 106.65 1730.29 52.7167 1971.99 57.7855",
    stroke: "url(#paint7_linear_1043_40040)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-57.5341 603.269C605.465 655.117 827.624 933.595 1125.89 670.205C1364.5 459.492 1876.06 532.473 2102.02 595.302",
    stroke: "url(#paint8_linear_1043_40040)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-58.9939 603.608C606.526 633.682 845.587 904.601 1127.35 631.705C1352.76 413.387 1868.3 469.535 2097.89 524.898",
    stroke: "url(#paint9_linear_1043_40040)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-57.735 602.829C609.048 605.646 868.525 866.366 1128.9 582.378C1337.21 355.188 1856.24 390.169 2089.72 436.059",
    stroke: "url(#paint10_linear_1043_40040)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-53.9429 601.725C612.254 581.131 888.612 832.441 1129.98 539.641C1323.07 305.401 1843.81 322.121 2080.04 359.761",
    stroke: "url(#paint11_linear_1043_40040)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.8081 602.141C602.472 569.367 887.373 815.541 1118.61 518.418C1303.59 280.719 1824.74 287.908 2062.19 321.215",
    stroke: "url(#paint12_linear_1043_40040)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-64.1641 602.66C598.43 548.123 898.184 784.715 1110.91 480.316C1281.09 236.796 1802.16 226.904 2041.42 252.398",
    stroke: "url(#paint13_linear_1043_40040)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-63.1076 601.734C594.26 520.193 911.701 744.158 1100.73 431.54C1251.96 181.444 1771.45 150.264 2012.29 165.936",
    stroke: "url(#paint14_linear_1043_40040)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-59.6359 600.167C591.598 495.643 923.43 708.205 1091.64 389.312C1226.21 134.198 1743.04 84.8167 1984.64 92.0154",
    stroke: "url(#paint15_linear_1043_40040)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_40040",
    x1: 1018,
    y1: 499,
    x2: 1018,
    y2: 758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_40040",
    x1: 1010.1,
    y1: 464.13,
    x2: 1018.58,
    y2: 722.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1043_40040",
    x1: 1000.2,
    y1: 419.658,
    x2: 1019.31,
    y2: 678.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1043_40040",
    x1: 991.751,
    y1: 381.434,
    x2: 1020.06,
    y2: 639.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1043_40040",
    x1: 975.556,
    y1: 362.787,
    x2: 1008.71,
    y2: 620.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1043_40040",
    x1: 959.436,
    y1: 329.39,
    x2: 1001.35,
    y2: 587.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1043_40040",
    x1: 939.134,
    y1: 286.843,
    x2: 992.209,
    y2: 544.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1043_40040",
    x1: 921.734,
    y1: 250.265,
    x2: 984.617,
    y2: 507.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1043_40040",
    x1: 1023.47,
    y1: 524.851,
    x2: 1021.19,
    y2: 783.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1043_40040",
    x1: 1016.1,
    y1: 489.853,
    x2: 1022.3,
    y2: 748.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1043_40040",
    x1: 1006.94,
    y1: 445.297,
    x2: 1023.75,
    y2: 703.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1043_40040",
    x1: 999.12,
    y1: 407,
    x2: 1025.11,
    y2: 665.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1043_40040",
    x1: 983.238,
    y1: 388.213,
    x2: 1014.05,
    y2: 646.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1043_40040",
    x1: 967.671,
    y1: 354.677,
    x2: 1007.22,
    y2: 612.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1043_40040",
    x1: 948.075,
    y1: 311.954,
    x2: 998.723,
    y2: 569.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1043_40040",
    x1: 931.281,
    y1: 275.224,
    x2: 991.679,
    y2: 532.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeElement02);
export default __webpack_public_path__ + "static/media/be_element_02.f63cd25386ca5d2b3432cb525204f782.svg";
export { ForwardRef as ReactComponent };